import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import ScrollProgress from "@/components/ScrollProgress";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import AdamsWay from "@/components/AdamsWay";
import InterestList from "@/components/InterestList";
import Impact from "@/components/Impact";
import News from "@/components/News";
import GetInvolved from "@/components/GetInvolved";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminPage from "@/components/AdminPage";

function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <div className="App noise" data-testid="app-root">
      <ScrollProgress />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <AdamsWay />
        <InterestList />
        <Impact />
        <News />
        <GetInvolved />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

function App() {
  if (window.location.pathname.startsWith("/admin")) {
    return <AdminPage />;
  }
  return <LandingPage />;
}

export default App;
